module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('h5', [_vm._v("Update Group Details")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Group Title"
    },
    model: {
      value: (_vm.group.name),
      callback: function($$v) {
        _vm.$set(_vm.group, "name", $$v)
      },
      expression: "group.name"
    }
  }), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "label": "Select privacy",
      "required": "",
      "return-object": "",
      "items": [{
        text: 'Public Group',
        value: 1
      }, {
        text: 'Closed Group',
        value: 2
      }]
    },
    model: {
      value: (_vm.group.privacy),
      callback: function($$v) {
        _vm.$set(_vm.group, "privacy", $$v)
      },
      expression: "group.privacy"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "textarea": "",
      "label": "Group Title"
    },
    model: {
      value: (_vm.group.description),
      callback: function($$v) {
        _vm.$set(_vm.group, "description", $$v)
      },
      expression: "group.description"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "green"
    },
    on: {
      "click": _vm.updateGroup
    }
  }, [_vm._v("\n                                UPDATE\n                            ")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "ml-3",
    attrs: {
      "md5": ""
    }
  }, [_c('h5', [_vm._v("Delete Group")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "red",
      "dark": ""
    },
    slot: "activator"
  }, [_vm._v("DELETE GROUP")]), _vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Are you sure you want to delete the group?")]), _vm._v(" "), _c('v-card-text', [_vm._v("This is an irreversible action.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteGroup.apply(null, arguments)
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("No")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eeb2304e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/grouppage/settings.vue
// module id = 1733
// module chunks = 17